import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'teaser-cheapest-price';
const BLOCK_ID = 'teaser-cheapest-price';
const PLACEHOLDER_LABEL = 'Günstigster Preis';

export default function cheapestPrice(
    editor,
    { category = blockCategories.teaser }
) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        model: {
            defaults: {
                tagName: 'div',
                name: 'Cheapest Price',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-teaser-cheapest-price',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'checkbox',
                        name: 'priceLabel',
                        label: 'Preis mit Bezeichnung anzeigen',
                    },
                ],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Günstigster Preis',
        category,
        media: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-teaser-cheapest-price',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
